import React from "react";
import Tabs from "../Tabs/Tabs";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import VoucherBuilderWorkspace from "./VoucherBuilderWorkspace";
import DateHelper from "../DateHelper/DateHelper";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  ElementsConsumer,
  CardElement,
} from "@stripe/react-stripe-js";
import ErrorHelper from "../Errors/ErrorHelper";
import FixedFooter from "../admin/FixedFooter";
import Switch from "../Switch/Switch";

export default class VoucherBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      voucher: this.props.voucher,
      loading: false,
      sendEmail: true,
      sendText: false,
      recipient_type: "customer",
      activeTab: "general",
      takePayment: false,
      purchasePayment: null,
      renderSuccess: false,
      stripe: null,
      errors: null,
      displayNewCardForm: false,
      note_count: this.props.note_count || null,
      noteObj: {
        note: null,
        notable_type: "Voucher",
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null,
      },
    };

    if (this.state.voucher.expiration_date) {
      this.state.voucher.expiration_date = DateHelper.parseDateFromBackend(
        this.state.voucher.expiration_date
      );
    }

    this.onChangeSendEmail = this.onChangeSendEmail.bind(this);
  }

  async componentDidMount() {
    const stripe = await loadStripe(this.props.public_gateway_key);
    this.setState({ stripe: stripe });
  }

  render() {
    if (this.state.stripe) {
      return (
        <Elements
          stripe={this.state.stripe}
          options={{
            locale:
              navigator.languages && navigator.languages.length
                ? navigator.languages[0]
                : navigator.language,
          }}
        >
          <ElementsConsumer>
            {({ stripe, elements }) => [
              <div className="VoucherBuilder" key="VoucherBuilder">
                {this.props.new_record
                  ? 
                  <FixedFooter {...this.props} {...this.state} showSendEmail={true} onChangeSendEmail={this.onChangeSendEmail} showSendText={this.props.enable_messaging} onChangeSendText={this.onChangeSendText}/>
                  : 
                  null
                }
                <LoadingSpinner show={this.state.loading} />
                <ModalButtons
                  loading={this.state.loading}
                  buttons={this.buttons(elements)}
                />
                {this.state.errors
                  ? ErrorHelper.renderErrors(this.state.errors, [
                      "amount",
                      "cash_drawer",
                      "payment_customer",
                      "card",
                      "name_on_card",
                      "card_validation",
                      "recipient_name",
                      "recipient_email",
                      "delivery_date",
                    ])
                  : null}
                {this.state.renderSuccess ? (
                  <div className="panel panel-form">
                    <div className="jumbotron">
                      <h2 className="text-center">
                        <strong>{I18n.t("voucher_created")}!</strong>
                      </h2>
                      <p className="text-center">
                        {I18n.t("redemption_code")}:{" "}
                        {this.state.voucher.redemption_code}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="panel panel-form">
                    <Tabs tabs={this.tabs()} />
                    <VoucherBuilderWorkspace
                      {...this.state}
                      cash_drawers={this.props.cash_drawers}
                      new_record={this.props.new_record}
                      property_date={DateHelper.parseDateFromBackend(
                        this.props.property_date
                      )}
                      onChangeVoucherInputs={this.onChangeVoucherInputs}
                      date_format={this.props.date_format}
                      time_format={this.props.time_format}
                      onChangeCustomer={this.onChangeCustomer}
                      onChangeSwitch={this.onChangeSwitch}
                      onChangePaymentInputs={this.onChangePaymentInputs}
                      onChangePurchaseCustomer={this.onChangePurchaseCustomer}
                      purchase_payment_path={this.props.purchase_payment_path}
                      voucher_payments_path={this.props.voucher_payments_path}
                      sent_email_data_table_path={this.props.sent_email_data_table_path}
                      scheduled_email_data_table_path={this.props.scheduled_email_data_table_path}
                      toggleAddNewCard={this.toggleAddNewCard}
                      onChangeNameOnCard={this.nameOnCardChange}
                      changeNoteObj={this.changeNoteObj}
                      voucher_notes_path={this.props.voucher_notes_path}
                      buttons={this.buttons(elements)}
                    />
                    { this.props.new_record ?
                    <div className="row" style={{marginTop: '15px'}}>
                      <div className="col-md-12">
                        <div className="float-right form-group">
                          <label style={{marginBottom: '0px'}}>
                            {I18n.t('send_email')} <span className="ss-help help" title={I18n.t('send_email_alert')}></span>
                          </label>
                          <Switch 
                            onText="yes" 
                            offText="no" 
                            onChange={this.onChangeSendEmail} 
                            value={this.state.sendEmail} 
                            switchId="send-email-switch"
                          />            
                        </div>
                      </div>
                    </div>
                    : null}
                  </div>
                )}
              </div>,
            ]}
          </ElementsConsumer>
        </Elements>
      );
    } else {
      return null;
    }
  }

  tabs = () => {
    const tabs = [
      {
        tabName: I18n.t("general"),
        targetName: "general",
        classes: this.state.activeTab === "general" ? "active" : null,
        changeHandler: this.onChangeTab,
      },
      {
        tabName: I18n.t("notes"),
        targetName: "notes",
        classes: this.state.activeTab === "notes" ? "active" : null,
        changeHandler: this.onChangeTab,
      },
    ];

    if (!this.props.new_record) {
      tabs.splice(1, 0, {
        tabName: I18n.t("purchase_payment"),
        targetName: "purchasePayment",
        classes: this.state.activeTab === "purchasePayment" ? "active" : null,
        changeHandler: this.onChangeTab,
      });

      tabs.splice(2, 0, {
        tabName: I18n.t("voucher_payments"),
        targetName: "voucherPayments",
        classes: this.state.activeTab === "voucherPayments" ? "active" : null,
        changeHandler: this.onChangeTab,
      });
      tabs.splice(3, 0, {
        tabName: I18n.t("emails"),
        targetName: "emails",
        classes: this.state.activeTab === "emails" ? "active" : null,
        changeHandler: this.onChangeTab,
      });
    }

    return tabs;
  };

  buttons = (elements = null) => {
    if (this.state.renderSuccess) {
      return [
        {
          name: I18n.t("ok"),
          html_attributes: ['data-dismiss="modal"'],
          onClick: () => {
            parent.refresh_data();
            parent.hide_modal();
          },
        },
      ];
    } else {
      return [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: this.props.new_record ? I18n.t("create") : I18n.t("submit"),
          button_classes: ["primary"],
          onClick: () => {
            this.processVoucher(elements);
          },
        },
      ];
    }
  };

  onChangeTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  onChangeVoucherInputs = (e) => {
    const voucher = Object.assign({}, this.state.voucher);
    voucher[e.target.name] = e.target.value;
    if ((e.target.name === "recipient_name" || e.target.name === "recipient_email") && (e.target.value && e.target.value !== '')) {
      voucher.customer = {};
    }
    this.setState({voucher: voucher});
  };

  onChangePaymentInputs = (e) => {
    const updatedState = Object.assign({}, this.state);
    updatedState.purchasePayment[e.target.name] = e.target.value;
    this.setState(updatedState);
  };

  onChangeSwitch = (e) => {
    const updatedState = Object.assign({}, this.state);
    updatedState.takePayment = e.target.checked;

    if (e.target.checked) {
      updatedState.purchasePayment = {
        paymentType: "card",
        card: { save_card: true, name_on_card: null },
        disableNameOnCard: false,
      };
    } else {
      updatedState.purchasePayment = null;
    }

    this.setState(updatedState);
  };

  onChangeCustomer = (customer) => {
    const updatedState = Object.assign({}, this.state);
    updatedState.voucher.customer = customer;
    updatedState.voucher.recipient_name = customer.full_name;
    updatedState.voucher.recipient_email = customer.email;
    this.setState(updatedState);
  };

  onChangePurchaseCustomer = (customer) => {
    const updatedState = Object.assign({}, this.state);
    updatedState.purchasePayment.customer = customer;
    if (customer.cards && customer.cards.length) {
      updatedState.purchasePayment.card = null;
      updatedState.displayNewCardForm = false;
    } else {
      updatedState.purchasePayment.card = {
        save_card: true,
        name_on_card: null,
      };
      updatedState.displayNewCardForm = true;
    }

    this.setState(updatedState);
  };

  toggleAddNewCard = () => {
    const updatedState = Object.assign({}, this.state);
    if (this.state.displayNewCardForm) {
      updatedState.purchasePayment.card = null;
      updatedState.displayNewCardForm = false;
      this.setState(updatedState);
    } else {
      updatedState.purchasePayment.card = {
        save_card: true,
        name_on_card: null,
      };
      updatedState.purchasePayment.card_id = null;
      updatedState.displayNewCardForm = true;
      this.setState(updatedState);
    }
  };

  nameOnCardChange = (e) => {
    const updatedState = Object.assign({}, this.state);
    updatedState.purchasePayment.card.name_on_card = e.target.value;
    this.setState(updatedState);
  };

  changeNoteObj = (note) => {
    const updateNoteObj = Object.assign({}, this.state.noteObj);
    if (note.target) {
      updateNoteObj.flagged = note.target.checked;
      this.setState({ noteObj: updateNoteObj });
    } else if (note.file_uploads) {
      this.setState({ file_uploads: note.file_uploads });
    } else {
      updateNoteObj.note = note;
      this.setState({ noteObj: updateNoteObj });
    }
  };

  processVoucher = async (elements) => {
    const errors = {};

    if (!this.state.voucher.amount || this.state.voucher.amount <= 0) {
      errors.amount = [I18n.t("must_be_greater_than_zero")];
    }

    if (!this.state.takePayment && Object.keys(errors).length == 0) {
      this.onSave();
    } else {
      if (this.state.purchasePayment) {
        if (
          !this.state.purchasePayment.customer ||
          !this.state.purchasePayment.customer.id
        ) {
          errors.payment_customer = [I18n.t("cant_be_blank")];
        }

        if (
          this.state.purchasePayment.paymentType == "cash" &&
          !this.state.purchasePayment.cash_drawer_id
        ) {
          errors.cash_drawer = [I18n.t("cant_be_blank")];
        }

        if (
          this.state.purchasePayment.paymentType == "card" &&
          !this.state.purchasePayment.card_id &&
          !this.state.displayNewCardForm
        ) {
          errors.card = [I18n.t("cant_be_blank")];
        }

        if (
          this.state.purchasePayment.paymentType == "card" &&
          !this.state.purchasePayment.card_id &&
          this.state.displayNewCardForm
        ) {
          if (
            !this.state.purchasePayment.card.name_on_card ||
            /\d/.test(this.state.purchasePayment.card.name_on_card)
          ) {
            errors.name_on_card = [I18n.t("must_match")];
          }

          if (
            this.state.purchasePayment.card &&
            !this.state.purchasePayment.card.token &&
            this.state.purchasePayment.card.name_on_card
          ) {
            const cardResponse = await this.generateCardToken(elements);

            if (cardResponse.error) {
              errors.card_validation = [cardResponse.error.message];
            } else if (cardResponse.paymentMethod) {
              const updatedState = Object.assign({}, this.state);

              updatedState.purchasePayment.card.token =
                cardResponse.paymentMethod;

              this.setState(updatedState);
            } else {
              console.log("should not hit here potential async issue");
            }
          }
        }
      }

      if (Object.keys(errors).length == 0) {
        if (typeof cardResponse != "undefined") {
          this.onSave(cardResponse);
        } else {
          this.onSave();
        }
      } else {
        this.setState({ errors: errors });
      }
    }
  };

  generateCardToken = async (elements) => {
    var stripe = this.state.stripe;
    var cardElement = elements.getElement(CardElement);

    if (!stripe || !cardElement) {
      console.log(
        "We should never hit this! Either Stripe or Elements is not loaded!"
      );
      return;
    }

    return await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name: this.state.purchasePayment.card.name_on_card,
      },
    });
  };


  onChangeSendEmail(e) {
    this.setState({ sendEmail: e.target.checked });
  }

  onChangeSendText(e) {
    this.setState({ sendText: e.target.checked });
  }

  onSave = (cardToken = null) => {
    this.setState({ loading: true });

    let paymentToken = null;

    if (cardToken) {
      paymentToken = cardToken;
    } else if (
      this.state.purchasePayment &&
      this.state.purchasePayment.card &&
      this.state.purchasePayment.card.token
    ) {
      paymentToken = this.state.purchasePayment.card.token;
    }

    $.ajax({
      type: this.props.new_record ? "POST" : "PUT",
      url: this.props.path,
      data: {
        voucher: {
          id: this.state.voucher.id,
          send_email: this.state.sendEmail,
          send_text: this.state.sendText,
          amount: this.state.voucher.amount,
          recipient_name: this.state.voucher.customer && this.state.voucher.customer.full_name ? this.state.voucher.customer.full_name : this.state.voucher.recipient_name,
          recipient_email: this.state.voucher.customer && this.state.voucher.customer.email ? this.state.voucher.customer.email : this.state.voucher.recipient_email,
          message: this.state.voucher.message,
          delivery_date: this.state.voucher.delivery_date,
          expiration_date: this.state.voucher.expiration_date,
          customer_id: this.state.voucher.customer
            ? this.state.voucher.customer.id
            : null,
        },
        note: this.state.noteObj.note ? this.state.noteObj : null,
        file_group_files:
          this.state.file_group && this.state.file_group.file_uploads
            ? this.state.file_group.file_uploads.map((file) => file.id)
            : null,
        purchase_payment: this.state.purchasePayment
          ? this.setPaymentParams(
              this.state.purchasePayment,
              paymentToken ? paymentToken : null
            )
          : null,
      },
    }).done((response) => {
      if (response.errors) {
        this.setState({ errors: response.errors, loading: false });
      } else if (response.data && response.data.id) {
        this.setState({
          renderSuccess: true,
          voucher: response.data,
          loading: false,
          errors: null,
        });
      }
    });
  };

  setPaymentParams = (payment, cardToken = null) => {
    return {
      payment_type: payment.paymentType,
      cash_drawer_id: payment.cash_drawer_id ? payment.cash_drawer_id : null,
      customer_id: payment.customer ? payment.customer.id : null,
      card_id: payment.card_id ? payment.card_id : null,
      card_token: cardToken ? cardToken : null,
      save_card: payment.card ? payment.card.save_card : null,
    };
  };
}
